<script>
  import {getContext} from 'svelte';
  import {env, envUtil, timeUtil} from '@/helper';
  import {bannerList$} from '../streams';
  import {sd} from '@/da';

  const LG = getContext('LG');

  let timer = null;
  let marqId = 0;
  let scrollerTransaction = 'all 0.1s';
  let marqWrap = null;
  let scroller = null;

  $: bannerList = $bannerList$.list
  $: marquee = bannerList.length > 0 ? [...bannerList, bannerList[0]] : [];
  $: autoPlay(marquee);
  $: scrollHeight = envUtil.isMobile ? 20 : 22;

  function autoPlay(marq) {
    if (timer) {
      clearInterval(timer);
    }
    if (marq.length > 2) {
      timer = setInterval(() => {
        const bool = marqId >= marq.length - 1;
        scrollerTransaction = 'all 0.2s';
        marqId = bool ? 0 : marqId + 1;
        if (marqId >= marq.length - 1) {
          setTimeout(() => {
            scrollerTransaction = 'all 0';
            marqId = 0;
          }, 1000);
        }
      }, 8000);
    }
  }

  function promotionClickHandler(item, index) {
    return function (e) {
      e.preventDefault();
      handleBannerClick(item, index);
      location.href = item.detail.webLink;
    };
  }

  function handleBannerClick(item, index) {
    const isMobileOrApp = env.isMobile || env.isApp;
    sd.track('banner_click', {
      banner_index: index,
      banner_url: item.detail.webLink,
      banner_lang: item.lang,
      banner_source_page: 'home',
      scene_type: item.detail.sceneType,
      banner_label: item.detail.bannerLabel,
      platform: isMobileOrApp ? (env.isMobile ? 'H5' : 'app_h5') : 'Web',
    });
  }
</script>

<style>
  .marquee-wrap {
    margin-top: 48px;
    box-sizing: border-box;
    width: 100%;
    gap: 6px;
  }
  .marquee-wrap > a:hover {
    color: #fff;
  }
  .marquee {
    height: 22px;
    line-height: 22px;
    overflow: hidden;
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;
    max-width: 420px;
  }
  .marquee::-webkit-scrollbar {
    width: 0;
  }
  .maq-item {
    scroll-snap-align: start;
  }
  .maq-item:hover {
    opacity: 0.8;
  }
  .maq-item .desc {
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .date {
    color: #888b94;
  }
  .arrow {
    transform: rotate(270deg) translateX(-1px);
  }
  @media screen and (max-width: 640px) {
    .marquee-wrap {
      width: 100%;
    }
    .marquee {
      flex: 1;
    }
    .maq-item {
      text-align: left;
    }
  }
</style>

{#if marquee.length > 0}
  <div class="marquee-wrap df aic TW xs:dn" on:click|stopPropagation>
    <img width="20" height="20" src="https://img.phemex.com/v1/3a41253a-e0a7-4d39-93d6-0241adc719d2/notification.svg" alt="" />
    <div class="marquee ooo" bind:this={marqWrap}>
      <div bind:this={scroller} style={`transform: translateY(-${marqId * scrollHeight}px);transition: ${scrollerTransaction}`}>
        {#each marquee as marq, index}
          <div class="maq-item df aic cp" on:click={promotionClickHandler(marq, index)}>
            <div class="desc">{marq.detail.description}</div>
            <div class="date ml6 xs:dn">{timeUtil.formatMonthDay(marq.releaseTime, '-')}</div>
          </div>
        {/each}
      </div>
    </div>
  </div>
{/if}
